import React from "react"
import { View, TouchableOpacity } from "react-native"
import LockIcon from "@/assets/icons/lock-icon.svg"
import PlusIcon from "@/assets/icons/plus-circle.svg"
import { Body, H3, H5, Title } from "../standard/BFText"
import ToolTips from "@/constants/ToolTips"
import { CopilotStep } from "react-native-copilot"
import { WalkthroughableView } from "@/components/copilot/WalkthroughableComponents"
import { type AnalysisType } from "@/generated/graphql"
import { useAnalyzeContext } from "@/components/analysis/AnalyzeContext"

interface CompSelectionOverlayProps {
  onSelectForMe: () => void
  analysis?: AnalysisType
}

const CompSelectionIntroOverlay: React.FC<CompSelectionOverlayProps> = ({
  onSelectForMe,
}) => {
  const { isFirstManualAnalysisDisplay, isTourActive } = useAnalyzeContext()

  if (!isFirstManualAnalysisDisplay) {
    return null
  }

  const buttonStyle = isTourActive ? "bg-grey" : "bg-midnight-blue"
  const textStyle = isTourActive ? "text-warm-grey" : "text-teal"

  return (
    <>
      <CopilotStep
        text={ToolTips.copilotStep1SelectComps}
        order={1}
        name="select comps"
        active={isFirstManualAnalysisDisplay}
      >
        <WalkthroughableView
          key={isTourActive ? "active" : "inactive"}
          style={{
            zIndex: 5,
            flex: 1,
            width: "100%",
            position: "absolute",
          }}
        >
          <View className="inset-0 z-50 bg-calm-blue/95 p-5 items-center justify-center w-full flex-1">
            <LockIcon className="size-6 text-white" />
            <H3 className="text-white text-xl text-center pt-2 my-2">
              Select comps below to get your ARV
            </H3>
            <Body className="text-white text-base text-center mb-2">
              Use{" "}
              <PlusIcon
                width={16}
                height={16}
                className="size-4 text-white inline"
              />{" "}
              to choose comps
            </Body>
            <Title className="text-white text-base mb-3 mt-4">Or</Title>
            <TouchableOpacity
              testID="select-for-me-button"
              className={`${buttonStyle} py-2.5 px-5 rounded-full`}
              onPress={onSelectForMe}
            >
              <H5 className={`${textStyle}`}>Select for Me</H5>
            </TouchableOpacity>
          </View>
        </WalkthroughableView>
      </CopilotStep>
    </>
  )
}

export default CompSelectionIntroOverlay
